import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { DEFAULT_THEME, THEME, themes } from '../../constants/themes/themes';
export const ThemeProviderContext = createContext({
    theme: themes[DEFAULT_THEME],
    setTheme: () => null,
});
export const ThemeProvider = ({ children, theme, local = false }) => {
    const [currentTheme, setCurrentTheme] = useState(themes[DEFAULT_THEME]);
    const ref = useRef(null);
    const toggleThemeClasses = (element, type) => {
        if (themes[type].name === THEME.DARK) {
            element.classList.add('dark');
            element.classList.remove('light');
            return;
        }
        element.classList.add('light');
        element.classList.remove('dark');
    };
    const setTheme = useCallback((type) => {
        setCurrentTheme(themes[type]);
        if (!local) {
            toggleThemeClasses(document.documentElement, type);
            return;
        }
        if (!ref.current) {
            return;
        }
        toggleThemeClasses(ref.current, type);
    }, [local]);
    useEffect(() => {
        theme && setTheme(theme);
    }, [theme, setTheme]);
    return (_jsx(ThemeProviderContext.Provider, { value: { theme: currentTheme, setTheme }, children: _jsx("div", { className: "not-supports-dvh:h-full", ref: ref, children: children }) }));
};
